const ACCESS_TOKEN = 'accessToken'
const REFRESH_TOKEN = 'refreshToken'
const APP_KEY = 'appKey'

export const getToken = () => {
    return window.localStorage.getItem(ACCESS_TOKEN)
}

export const saveToken = token => {
    window.localStorage.setItem(ACCESS_TOKEN, token)
}

export const getRefreshToken = () => {
    return window.localStorage.getItem(REFRESH_TOKEN)
}

export const saveRefreshToken = refresh => {
    window.localStorage.setItem(REFRESH_TOKEN, refresh)
}

export const getAppKey = () => {
    return window.localStorage.getItem(APP_KEY)
}

export const saveAppKey = appKey => {
    window.localStorage.setItem(APP_KEY, appKey)
}

export const destroyToken = () => {
    window.localStorage.removeItem(ACCESS_TOKEN)
}

export const destroyRefreshToken = () => {
    window.localStorage.removeItem(REFRESH_TOKEN)
}

export const destroyAppKey = () => {
    window.localStorage.removeItem(APP_KEY)
}

export const AuthorizationHeader = {
    Authorization: 'Bearer '+ getToken()
}

export default {
    getToken,
    saveToken,
    getRefreshToken,
    saveRefreshToken,
    destroyToken,
    destroyRefreshToken,
    getAppKey,
    saveAppKey,
    destroyAppKey,
    AuthorizationHeader
}
